<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <Step4Block :class="{ 'step4block-additional': index }" ref="benefi" :active="active" v-for="(b, index) in beneficiaries" :key="b.key" :index="index" @setCopy="Step4BlockCopied = $event" :copyEnabled="!Step4BlockCopied" @filledChanged="filledBeneficiaries[index] = $event" @dataChanged="setBenificiary(index, $event)">
        <h3 class="step__title" :class="{ 'step__title_special': index, 'step__title_topmg': index }">Данные Выгодоприобретателя<br class="onlydesk"> (Застрахованного&nbsp;лица)
          <div class="step4block-additional__close" v-if="index" @click="removeBeneficiary(index)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 5V13M10 5V13M1 3H15M6 1H10M3 3H13V15H3V3Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </h3>
      </Step4Block>
      <AddBtn class="step4__addbutton" @click="addBeneficiary">Указать еще одного Выгодоприобретателя (наследника)</AddBtn>
      <div class="step__line"></div>
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="toNext">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import AddBtn from '../AddBtn.vue';
import Step4Block from './Step4Block.vue';
import { mapState } from 'vuex';
import nameSuggest from '../../mixins/nameSuggest';
export default {
  props: {
    active: { type: Boolean, default: false }
  },
  mixins: [nameSuggest],
  data: () => ({
    Step4BlockCopied: false,
    errors: {},
    beneficiaries: [{ key: 1 }],
    filledBeneficiaries: [false],
    key: 2
  }),
  components: { Step4Block, Btn, AddBtn },
  created() {
    window.onbeforeunload = () => {
      if (this.$store.state.dev.deleteSaveAfterSuccess && !this.$store.state.show) { // (!state.show) === state.formSuccessfullySended
        localStorage.removeItem('personal_form')
      }
      else {
        this.$store.dispatch('makeSave', this.beneficiaries)
      }
    }
  },
  beforeMount() {
    while( this.beneficiaries.length < this.form.beneficiaries.length)
      this.addBeneficiary()
  },
  methods: {
    setBenificiary(index, data) {
      this.beneficiaries[index] = { ...data, key: this.beneficiaries[index].key }
    },
    addBeneficiary() {
      this.filledBeneficiaries.push(false)
      this.beneficiaries.push({ "name": "", "fullcopy": false, "addresscopy": false, "birthdate": "", "doc": { "type": "", "series": "", "number": "", "code": "", "code_info": "", "releasedate": "" }, "address": { address: '', flat: '', noflat: false }, "INN": "", "publicPerson": false, "PDL": { "name": "", "position": "", "employer": "", "employer_address": { address: '', flat: '', noflat: false }, "income": { "salary": false, "pension": false, "inherit": false, "savings": false, "percentages": false, "business": false, "others": "" } }, "relationship": "", "insuredperson": { "copy": false, "name": "", "birthdate": "" }, "FATCA": { "enabled": false, "USACitizen": null, "USAResidencePermit": null, "bornInUSA": null, "renunciation": null, "longPeriod": null, "haveaddress": null, "havephone": null, "taxResident": null, "SSN": "", "ITIN": "", "name": "", "agreementItsTrue": false, "agreementIKnowConsequenses": false }, "TRD": { "enabled": false, "name": "", "namecopied": false, "data": [{ "country": "", "INN": "" }], "additional": "" }, "key": this.key++ })
    },
    removeBeneficiary(index) {
      this.filledBeneficiaries = this.filledBeneficiaries.filter((el, i) => i != index)
      this.beneficiaries = this.beneficiaries.filter((el, i) => i != index)
    },
    toNext() {
      this.$store.commit('setBeneficiaries', this.beneficiaries)
      this.$store.commit('nextStep')
    },
  },
  computed: {
    ...mapState(['form']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (this.filledBeneficiaries.includes(false)) return false
      return true
    }
  },
}
</script>

<style lang="sass">
.step4__addbutton
  width: 585px
  max-width: 100%
  @include for-mob
    .addbtn__text
      text-align: left
</style>